import { render } from "./InsuranceModel.vue?vue&type=template&id=4805cef9&scoped=true&ts=true"
import script from "./InsuranceModel.vue?vue&type=script&lang=ts"
export * from "./InsuranceModel.vue?vue&type=script&lang=ts"

import "./InsuranceModel.vue?vue&type=style&index=0&id=4805cef9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4805cef9"]])

export default __exports__